import { render } from "./Error500.vue?vue&type=template&id=ab44c952&scoped=true"
const script = {}

import "./Error500.vue?vue&type=style&index=0&id=ab44c952&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab44c952"]])

export default __exports__